module.exports = __webpack_public_path__ + "img/8.b3adf361.jpg";